import Vue from "vue";

Vue.component("notes-search-results", {
	props: ["searchResults"],
	data() {
		return {
			isOpen: null,
			labels: {
				notes: window.labels.notes,
				footnotes: window.labels.footnotes
			},
		};
	},
	template: `
		<div>
			<b-collapse
				class="card mb-2"
				animation="slide"
				v-for="(party, index) of searchResults.parties"
				:key="'party-' + index"
				:open="isOpen == index"
				@@open="isOpen = index">
				<template #trigger="props">
					<div class="card-header pt-1 pb-1" role="button">
						<p class="card-header-title">
							{{ party.name }}
						</p>
					</div>
				</template>
				<div class="card-content">
					<div class="content">
						<b-collapse v-for="annex in party.annexes" :key="annex.id" :open="false">
							<template #trigger>
								<div style="font-weight: bold; text-transform: uppercase" v-html="annex.name"></div>
								<div class="horizontal-spacer-10"></div>								
							</template>
							<div class="notification has-background-white">
								<div class="content">
									<template v-if="annex.notes.length > 0 && annex.footnotes.length > 0">
										<b-collapse :open="false">
											<template #trigger>
												<span style="font-weight: bold; text-transform: uppercase">{{ labels.notes }}</span>
											</template>
											<annex-notes :level="0" :notes="annex.notes"></annex-notes>
										</b-collapse>
										<b-collapse :open="false">
											<template #trigger>
												<span style="font-weight: bold; text-transform: uppercase">{{ labels.footnotes }}</span>
											</template>
											<annex-notes :level="0" :notes="annex.footnotes"></annex-notes>
										</b-collapse>
									</template>
									<template v-else>
										<annex-notes :level="0" :notes="annex.notes"></annex-notes>
										<annex-notes :level="0" :notes="annex.footnotes"></annex-notes>
									</template>
								</div>
							</div>
						</b-collapse>
					</div>
				</div>
			</b-collapse>
		</div>
	`
});